<template>
  <div>
    <BaseUploadExcel
      ref="baseUploadExcel"
      :headers="headers"
      :xlsxFileSchema="xlsxFileSchema"
      openOut
      :isUseOriginTable="false"
      @onUploadSuccess="data => onUploadSuccess(data)"
    >
      <v-list>
        <v-list-item
          v-if="$auth.policies['import-deliveries:save-schedules'] && delivery.status === 'open'"
          @click="getFileExcel"
          class="cursor-pointer item1"
          >Tải lên file (Excel)</v-list-item
        >
        <v-list-item @click="downloadFile" class="cursor-pointer item2">Tải xuống file mẫu (Excel)</v-list-item>
      </v-list>
    </BaseUploadExcel>
    <TableViewFileImportExcel ref="table-view" @onSave="onSave" @onCloseDialog="onCloseDialog" />
  </div>
</template>

<script>
import BaseUploadExcel from '@/components/samnec/base-upload-excel/BaseUploadExcel.vue'
import TableViewFileImportExcel from './TableInventory/TableViewFileImportExcel.vue'
import utils from '@/plugins/utils'
import { mapActions, mapState } from 'vuex'
import { get } from 'lodash'
import moment from 'moment'

export default {
  components: {
    BaseUploadExcel,
    TableViewFileImportExcel
  },
  data() {
    return {
      headers: [
        { text: 'Mã kho', value: 'name_short' },
        { text: 'Tên kho', value: 'name' },
        { text: 'Model', value: 'code' },
        { text: 'Mô tả', value: 'description' },
        { text: 'Số lượng', value: 'quantity' },
        { text: 'Ngày nhập', value: 'deliveredAt' }
      ],
      xlsxFileSchema: {
        'Mã kho': { prop: 'name_short', type: String },
        'Tên kho': { prop: 'name', type: String },
        Model: { prop: 'code', type: String },
        'Mô tả': { prop: 'description', type: String },
        'Số lượng': { prop: 'quantity', type: Number },
        'Ngày nhập': { prop: 'deliveredAt', type: String }
      },
      dataToSave: []
    }
  },
  computed: {
    ...mapState({
      delivery(state) {
        return state['importDeliveries'].item
      }
    })
  },
  methods: {
    ...mapActions({
      importDeliveryExcel: 'importDeliveries/importDeliveryExcel'
    }),
    getFileExcel() {
      this.$refs['baseUploadExcel'].onUpload()
    },
    validate(data) {
      let errorDatas = []
      let formattedData = []

      data.forEach(item => {
        if (item.deliveredAt !== null) {
          formattedData.push({
            ...item,
            deliveredAt: this.formatDate(item.deliveredAt)
          })
        } else errorDatas.push(item)
      })
      if (errorDatas.length) {
        return this.$alert.error('Vui lòng kiểm tra lại ngày nhập')
      }
      this.dataToSave = data.map(v => ({ ...v, deliveredAt: moment(v.deliveredAt, 'DD/MM/YYYY').toISOString() }))
      return formattedData
    },

    onUploadSuccess(data) {
      if (Array.isArray(data) && data.length) {
        const r = this.validate(data)
        if (Array.isArray(r) && r.length) {
          this.$refs['table-view'].openDialog(r)
        }
      }
    },
    formatDate(date) {
      return moment(date, 'DD/MM/YYYY').format('DD/MM/YYYY')
    },
    async onSave() {
      try {
        this.$loading.active = true
        const deliveryId = this.$route.params.id
        this.dataToSave = this.dataToSave.filter(item => Number(item.quantity) > 0)
        if (!deliveryId) return this.$alert.error('Đã có lỗi xảy ra')
        await this.importDeliveryExcel({
          id: deliveryId,
          params: { listData: this.dataToSave }
        })
        this.$alert.success('Tải file excel thành công')
        this.$refs['table-view'].closeDialog()
        this.$emit('onRefresh')
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.$loading.active = false
      }
    },
    onCloseDialog() {
      this.$refs['baseUploadExcel'].cancel()
    },
    downloadFile() {
      try {
        this.$loading.active = true
        const nameFile = `${get(this.delivery, 'importOrderCode', '')} - Giao nhận theo đơn hàng nhập - ${get(
          this.delivery,
          'productIndustry.name',
          ''
        )} - ${get(this.delivery, 'producer.name', '')} - ${get(this.delivery, 'productType.name', '')}`
        const content = [
          {
            name_short: 'TD',
            name: 'Tràng Duệ',
            code: 'UA50AU7700KXXV',
            description: 'Tivi Samsung 50 inch',
            quantity: 10,
            deliveredAt: '01/01/2024'
          }
        ]
        utils.exportExcel(content, this.headers, nameFile)
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.$loading.active = false
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
